import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { Panel } from "../admin/fields";

const TYPES = { conference: "Conference", wedding: "Wedding", party: "Party", other: "Other" };

export const EnquiryList = ({ wid }) => {
  const { data = [], isLoading } = useQuery({ queryKey: ["enquiries", wid], queryFn: () => api.get(`/web/${wid}/enquiries`).then((r) => r.data) });
  return (
    <Panel title={`Received enquiries (${data.length})`} hint="Newest first. Reply to the guest by email or phone.">
      {isLoading ? <p className="text-sm text-ink/60">Loading...</p> : !data.length ? (
        <p className="text-sm text-ink/60" data-testid="enquiries-empty">No enquiries yet.</p>
      ) : (
        <div className="divide-y divide-ink/5 rounded-xl border border-ink/10" data-testid="enquiries-list">
          {data.map((e, i) => (
            <div key={`${e.created_at}-${i}`} className="grid gap-1 px-4 py-3 text-sm md:grid-cols-[160px_1fr]" data-testid={`enquiry-row-${i}`}>
              <div>
                <span className="rounded-full bg-brand/10 px-2 py-0.5 text-xs font-semibold text-brand">{TYPES[e.event_type] || e.event_type}</span>
                <p className="mt-1 text-xs text-ink/50">{new Date(e.created_at).toLocaleString()}</p>
              </div>
              <div className="min-w-0 break-words">
                <p className="font-semibold">{e.name}{e.organisation ? ` · ${e.organisation}` : ""}</p>
                <p className="text-ink/70">
                  <a href={`mailto:${e.email}`} className="text-brand underline-offset-2 hover:underline">{e.email}</a> · <a href={`tel:${e.phone}`}>{e.phone}</a>
                </p>
                <p className="text-ink/70">Date: {e.event_date || "Not decided"} · Guests: {e.guests}{e.rooms ? ` · Rooms: ${e.rooms}` : ""}</p>
                {e.message && <p className="mt-1 whitespace-pre-line text-ink/80">{e.message}</p>}
                <p className="mt-1 text-xs text-ink/45">{e.emailed_to?.length ? `Emailed to ${e.emailed_to.join(", ")}` : "Email not sent, check email settings"}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
